import clsx from 'clsx';
import { useState } from 'react';
import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import type { RootState } from '../../store';
import { bottomNavFor } from './nav';
import { MoreSheet } from './MoreSheet';
import { NavBadge } from './NavBadge';

const TAB = 'relative flex min-w-16 flex-1 flex-col items-center justify-center gap-0.5 text-micro';

/** Phones and tablets: up to four destinations plus More. Staff get Orders and Profile. */
export const BottomNav = () => {
    const { t } = useTranslation();
    const role = useSelector((s: RootState) => s.auth.user?.role?.name);
    const restaurantId = useSelector((s: RootState) => s.auth.user?.restaurant?.id);
    const [moreOpen, setMoreOpen] = useState(false);
    const { tabs, more } = bottomNavFor(role, restaurantId);

    return (
        <>
            <nav
                aria-label={t('shell.primary')}
                className="glass fixed inset-x-0 bottom-0 z-30 flex h-[calc(3.5rem+env(safe-area-inset-bottom))] border-b-0 border-t border-hairline pb-safe-b lg:hidden"
            >
                {tabs.map((item) => (
                    <NavLink
                        key={item.id}
                        to={item.to}
                        end={item.to === '/'}
                        className={({ isActive }) => clsx(TAB, isActive ? 'text-strong' : 'text-muted')}
                    >
                        {({ isActive }) => {
                            const Icon = isActive ? item.iconActive : item.icon;
                            return (
                                <>
                                    {isActive && <span aria-hidden="true" className="absolute inset-x-0 top-0 mx-auto h-[3px] w-6 rounded-b bg-accent" />}
                                    <span className="relative">
                                        <Icon className="size-6" aria-hidden="true" />
                                        {item.badge && <NavBadge className="absolute -right-3 -top-1.5" />}
                                    </span>
                                    {t(item.labelKey)}
                                </>
                            );
                        }}
                    </NavLink>
                ))}
                {more.length > 0 && (
                    <button type="button" onClick={() => setMoreOpen(true)} aria-haspopup="dialog" className={clsx(TAB, 'text-muted')}>
                        <EllipsisHorizontalIcon className="size-6" aria-hidden="true" />
                        {t('shell.more')}
                    </button>
                )}
            </nav>
            <MoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} items={more} />
        </>
    );
};
